import React, { useEffect, useRef } from 'react';
import observer from '../utils/observer';

const Card = ({
  cardText,
  cardHeader,
  cardNumber,
  altText,
  image,
  isVerticalImage,
  isReversed,
}) => {
  const refValue = useRef(null);

  useEffect(() => {
    observer(refValue, 'lazy-load-image');
  }, [refValue]);

  return (
    <div
      className={`card-container ${
        isReversed ? 'reversed-style' : 'not-reversed-style'
      }`}
      // style={checkReverse(reversedStyle, notReversedStyle)}
    >
      <div
        className={`card-number ${isReversed ? 'order3' : 'order1'}`}
        // style={checkReverse({ order: 3 }, { order: 1 })}
      >
        {cardNumber}
      </div>
      <div
        className={`card-image-container ${
          isReversed ? 'card-image-right' : 'card-image-left'
        }`}
        // style={checkReverse(
        //   {
        //     order: 2,
        //     justifyContent: 'right',
        //     alignItems: 'center',
        //     marginRight: '20px',
        //   },
        //   {
        //     order: 2,
        //     display: 'flex',
        //     justifyContent: 'left',
        //     alignItems: 'center',
        //     marginLeft: '20px',
        //   }
        // )}
      >
        <img
          className={`card-image ${
            isVerticalImage ? `card-vertical-image` : `card-horizontal-image`
          } lazy-load-image`}
          src={image}
          alt={altText}
          ref={refValue}
        />
      </div>
      <div
        className={`card-details ${isReversed ? 'order1' : 'order3'}`}

        // style={checkReverse({ order: 1 }, { order: 3 })}
      >
        <div className="card-header">{cardHeader}</div>
        <div className="card-text">{cardText}</div>
      </div>
    </div>
  );
};

export default Card;
